export default function SecondaryBadge({ imageUrl }: { imageUrl?: string }) {
  if (!imageUrl) return null;
  
  return (
    <div className="mb-4 inline-block mx-1">
      <img src={imageUrl} alt="Badge" className="h-8" />
    </div>
  );
} 